import React from "react";
import Img from "./basic/Img";

function ColumnTitle() {
    return (
        <div className="column">
            <Img fileName={"columnDecoPink"} className="column-deco-pink" />
            <Img fileName={"columnDecoYellow"} className="column-deco-yellow" />

            <Img
                fileName={"columnTitle"}
                className="column-title"
                width="329.76px"
                height="238.5px"
            />
            <Img
                fileName={"columnText"}
                className="column-text"
                width="329.76px"
                height="259.55px"
            />
        </div>
    );
}

export default ColumnTitle;
